import { Link } from "react-router-dom"

const EmptyHeader = () => <header className="w-100  shadow-sm bg-primary fixed-top" style={{ height: '57px' }}>
    <div className="d-flex align-items-center justify-content-center h-100 w-25">
        <Link to="/" className="text-white fw-bold text-uppercase">My Shop!</Link>
    </div>
</header >

export default EmptyHeader